module.exports = __webpack_public_path__ + "img/download_en.e44c0845.png";